import { render, staticRenderFns } from "./AccountLock.vue?vue&type=template&id=0280657a&scoped=true&"
import script from "./AccountLock.vue?vue&type=script&lang=ts&"
export * from "./AccountLock.vue?vue&type=script&lang=ts&"
import style0 from "./AccountLock.vue?vue&type=style&index=0&id=0280657a&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0280657a",
  null
  
)

export default component.exports